import script from "./GastronomyAmenitiesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./GastronomyAmenitiesSection.vue?vue&type=script&setup=true&lang=ts"

import "./GastronomyAmenitiesSection.vue?vue&type=style&index=0&id=7c4e8e14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4e8e14"]])

export default __exports__